module.exports = __webpack_public_path__ + "static/media/acid.5e5fe13c.svg";